import { Reducer } from 'redux';

import { Action, createAction } from '../../../store/actionUtils';

export interface Metadata {
    description: string;
    thumbnail: string;
    title: string;
}

export enum MetadataActionTypes {
    RECEIVE_METADATA = 'ShowsIndex/metadata/RECEIVE_METADATA',
}

export type ReceiveMetadataAction = Action<MetadataActionTypes.RECEIVE_METADATA, Metadata>;

const initialState: Metadata = {
    description: '',
    thumbnail: '',
    title: '',
};

const metadataReducer: Reducer<Metadata, ReceiveMetadataAction> = (state = initialState, action) => {
    switch (action.type) {
        case MetadataActionTypes.RECEIVE_METADATA:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

// Action creators
export const receiveMetadata = createAction<ReceiveMetadataAction>(
    MetadataActionTypes.RECEIVE_METADATA,
    doc => ({
        description: doc.meta_description,
        thumbnail: doc.meta_thumbnail,
        title: doc.meta_title,
    }),
);

export default metadataReducer;
